import { useParams } from "@tanstack/react-router";
import { usePublicRoomDisplayQuery } from "../api/queries";
import { DisplayAgendaPanel } from "../ui/DisplayAgendaPanel";
import { DisplayPosterSlideshow } from "../ui/DisplayPosterSlideshow";

export function RoomDisplayPage() {
  const { slug } = useParams({ from: "/display/$slug" });
  const query = usePublicRoomDisplayQuery(slug);

  if (query.isLoading) {
    return (
      <div className="flex h-svh items-center justify-center bg-neutral-100 text-neutral-500 text-xl">
        ກຳລັງໂຫຼດ…
      </div>
    );
  }

  if (query.isError || !query.data) {
    return (
      <div className="flex h-svh flex-col items-center justify-center gap-2 bg-neutral-100 text-neutral-700">
        <p className="font-medium text-2xl">ບໍ່ສາມາດສະແດງຜົນໄດ້</p>
        <p className="text-neutral-500">ບໍ່ພົບຈໍ ຫຼື ປິດໃຊ້ງານແລ້ວ</p>
      </div>
    );
  }

  const { date, items, posters } = query.data;

  return (
    <div className="grid h-svh grid-cols-1 overflow-hidden md:grid-cols-[3fr_2fr]">
      <section className="min-h-0 md:h-full">
        <DisplayPosterSlideshow posters={posters} />
      </section>
      <section className="min-h-0 border-neutral-200 border-t md:h-full md:border-t-0 md:border-l">
        <DisplayAgendaPanel date={date} items={items} />
      </section>
    </div>
  );
}
